/* tslint:disable */
/* eslint-disable */
/**
 * Integrations Service
 * Provides an API to integrate with various 3rd party integrations
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OpportunityDetailsRequest
 */
export interface OpportunityDetailsRequest {
    /**
     * 
     * @type {string}
     * @memberof OpportunityDetailsRequest
     */
    guid: string;
}

/**
 * Check if a given object implements the OpportunityDetailsRequest interface.
 */
export function instanceOfOpportunityDetailsRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "guid" in value;

    return isInstance;
}

export function OpportunityDetailsRequestFromJSON(json: any): OpportunityDetailsRequest {
    return OpportunityDetailsRequestFromJSONTyped(json, false);
}

export function OpportunityDetailsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): OpportunityDetailsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'guid': json['guid'],
    };
}

export function OpportunityDetailsRequestToJSON(value?: OpportunityDetailsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'guid': value.guid,
    };
}

